import React from "react";
import { HiOutlineSparkles } from "react-icons/hi";

interface WhatsNewButtonProps {
  count: number;
  onClick: () => void;
}

export const whatsNewLabel = (count: number) =>
  count > 0
    ? `What's new, ${count} new release${count === 1 ? "" : "s"}`
    : "What's new";

// Icon-only, in the same white circle as the help button beside it. The badge is the only
// signal: nothing opens, moves or pops up on its own.
const WhatsNewButton: React.FC<WhatsNewButtonProps> = ({ count, onClick }) => (
  <button
    type="button"
    className="whats-new-button tw-relative tw-inline-flex tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-cursor-pointer"
    onClick={onClick}
    aria-label={whatsNewLabel(count)}
    aria-haspopup="dialog"
    title="What's new"
  >
    <span className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-p-[3.5px]">
      <HiOutlineSparkles size={18} color="#03234a" aria-hidden="true" />
    </span>
    {count > 0 && (
      <span
        className="tw-absolute tw-top-[-7px] tw-right-[-9px] tw-min-w-[18px] tw-h-[18px] tw-px-1 tw-rounded-full tw-bg-[#d93036] tw-text-white tw-text-[11px] tw-font-bold tw-leading-[18px] tw-text-center tw-ring-2 tw-ring-[#03234a]"
        aria-hidden="true"
      >
        {count > 9 ? "9+" : count}
      </span>
    )}
  </button>
);

export default WhatsNewButton;
